import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./combinedReducer";

const store = configureStore({
  reducer: { ...rootReducer },
});

export default store;
